import { z } from 'zod';

import { isValidExpenseAmount } from '#/modules/momMgmt/workOrder/helper/workOrderExpenses';

const manufacturingQtySchema = z.union([z.string(), z.number()]).refine(
  (value) => value !== '' && value != null && !Number.isNaN(Number(value)) && Number(value) > 0,
  { message: '製造量須大於 0' },
);

const bomMaterialSelectionSchema = z.object({
  sourceGroupMaterialId: z.string().min(1),
  selectedMaterialId: z.string().min(1, '請選擇替代料'),
  sourceGroupMtrNo: z.string().optional().nullable(),
  sourceGroupMtrName: z.string().optional().nullable(),
});

/** 工單費用列（工單表單與異動單共用）。 */
export const workOrderExpenseRowSchema = z.object({
  expenseId: z.string().optional().nullable(),
  name: z.string().trim().min(1, '請填寫費用名稱'),
  amount: z.union([z.string(), z.number()]).refine(
    (value) => isValidExpenseAmount(value),
    { message: '金額須為 0 以上，最多 4 位小數' },
  ),
});

export const workOrderFormSchema = z.object({
  scheduledStartDate: z.string().min(1, '請填寫排程日'),
  issueReason: z.string().optional().nullable(),
  remark: z.string().optional().nullable(),
  mtrId: z.string().min(1, '請選擇成品'),
  mtrNo: z.string().optional().nullable(),
  mtrName: z.string().optional().nullable(),
  bomId: z.string().optional().nullable(),
  bomCode: z.string().optional().nullable(),
  bomName: z.string().optional().nullable(),
  bomVersion: z.string().optional().nullable(),
  bomStatus: z.string().optional().nullable(),
  processingFactoryId: z.string().optional().nullable(),
  workWarehouseId: z.string().min(1, '請選擇工作倉'),
  targetWarehouseId: z.string().min(1, '請選擇目標倉'),
  manufacturingQty: manufacturingQtySchema,
  bomMaterialSelections: z.array(bomMaterialSelectionSchema).default([]),
  expenses: z.array(workOrderExpenseRowSchema).default([]),
});

export const WORK_ORDER_FIELD_LABELS = {
  scheduledStartDate: '排程日',
  issueReason: '事由',
  remark: '備註',
  mtrId: '成品',
  processingFactoryId: '加工廠',
  workWarehouseId: '工作倉',
  targetWarehouseId: '目標倉',
  manufacturingQty: '製造量',
  bomMaterialSelections: '替代料選擇',
  'bomMaterialSelections.selectedMaterialId': '替代料',
  expenses: '費用',
  'expenses.name': '費用名稱',
  'expenses.amount': '費用金額',
};

export function resolveWorkOrderFieldLabel(path) {
  if (WORK_ORDER_FIELD_LABELS[path]) {
    return WORK_ORDER_FIELD_LABELS[path];
  }
  if (path?.startsWith('bomMaterialSelections.')) {
    return WORK_ORDER_FIELD_LABELS['bomMaterialSelections.selectedMaterialId'];
  }
  if (path?.startsWith('expenses.')) {
    return path.endsWith('.amount')
      ? WORK_ORDER_FIELD_LABELS['expenses.amount']
      : WORK_ORDER_FIELD_LABELS['expenses.name'];
  }
  return path;
}
